var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "drawer-accordion__head", on: { click: _vm.handleClick } },
      [
        _c("CompassIcon", {
          staticClass: "drawer-accordion__caret",
          attrs: { icon: "caret-right-fill", size: "extra-small" }
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "drawer-accordion__title typographies-paragraph-caps-small-bold"
          },
          [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
        ),
        _vm._v(" "),
        _vm._t("action")
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "accordionContent",
        staticClass: "drawer-accordion__content",
        style: _vm.contentMaxHeight
      },
      [
        _c(
          "div",
          {
            ref: "accordionContentWrapper",
            staticClass: "drawer-accordion__content-wrapper"
          },
          [_vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }